import React from "react";
import styled from "@emotion/styled";
import { Colors } from "./colors";
import Link from "./link";
import { withTranslation } from 'react-i18next';

class Foot extends React.Component {
  render() {
    // Render index
    return (
      <Footer>
        <FlexCol>
          <ColContent>
            <FlexRow>
              <img
                style={{ height: "57px", width: "100px" }}
                src="..\..\static\images\logo.svg"
                alt="Ratib Logo"
              />
              <TextLogo>
                <div>راتب | Ratib</div>
              </TextLogo>
            </FlexRow>
            <Links>
              <Link linkText={this.props.t("footer_home")} color="#fff" href="/" />
              <Link linkText={this.props.t("footer_tos")} color="#fff" href="/service" />
              <Link linkText={this.props.t("footer_contact")} color="#fff" href="/" />
              <Link linkText={this.props.t("navbar_about")} color="#fff" href="/about/" />
            </Links>
            <Link linkText={'Logos provided by Logo.dev'} color={Colors.slateGray} href="https://logo.dev" style={{fontSize: 12,}}/>
            <CopyRight>{this.props.t("copyright")}</CopyRight>
          </ColContent>
          <FlexBottom dir="ltr">
            <Corner />
            <Social>
              <a href="https://www.linkedin.com/company/ratib/" target="_blank">
                <img src="..\..\static\images\linkedin.svg" alt="LinkedIn" />
              </a>
              <a href="https://twitter.com/RatibKSA" target="_blank">
                <img src="..\..\static\images\twitter.svg" alt="Twitter" />
              </a>
              <a href="https://www.instagram.com/ratibksa/" target="_blank">
                <img src="..\..\static\images\insta.svg" alt="Instagram" />
              </a>
              <a href="https://www.tiktok.com/@ratibksa" target="_blank">
                <img src="..\..\static\images\tiktok.svg" alt="TikTok" />
              </a>
            </Social>
            <CornerR />
          </FlexBottom>
        </FlexCol>
      </Footer>
    );
  }
}
export default withTranslation()(Foot);

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

// Create a flex column display div
const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: inherit;
  width: 100%;
`;

const ColContent = styled(FlexCol)`
  justify-content: flex-end;
  gap: 16px;
`;

const FlexBottom = styled(FlexRow)`
  bottom: 0;
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;
`;

const TextLogo = styled.div`
  height: 23px;
  width: 115px;
  color: ${Colors.white};
  direction: rtl;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: normal;
  text-align: center;
  top: 0;
  white-space: nowrap;
  width: 113px;
`;
const Links = styled(FlexRow)`
  text-decoration: none;
  color: ${Colors.white};
  width: 25%;
  justify-content: space-between;
  min-width: 320px;
`;

const CopyRight = styled.div`
  color: ${Colors.white};
  width: 55%;
  text-align: center;
  font-size: 12px;
`;

const Social = styled(FlexRow)`
  justify-content: space-between;
  height: 1.66vw;
  width: 10%;
  margin: 10px;
  min-width: 115px;
`;
const Corner = styled.div`
  background-color: ${Colors.ratibBlue};
  border: 0px solid;
  border-color: ${Colors.black};
  border-radius: 0px 100px 0px 0px;
  height: 80%;
  width: 40%;
`;

const CornerR = styled(Corner)`
  transform: rotateY(180deg);
`;

const Footer = styled(FlexCol)`
  box-sizing: border-box;
  background-color: ${Colors.spaceGray}; /* Match the navbar color */
  border: 0px solid;
  border-color: ${Colors.black};
  height: 224px;
  width: 100%;
`;
